import './nav-bar.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSNavBar } from './nav-bar';

components.register({
	selector: '.gs-NavBar',
	controller: GSNavBar
});
